// Documenti di Progetto (Bilanci / Trasparenza) — client API.
import { api, unwrap } from './client';

const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

export const projectDocsService = {
  // Pubblico
  listBilanci: (category = 'bilancio') => unwrap(api.get('/project-docs/bilanci', { params: { category } })),
  // Admin
  adminList: () => unwrap(api.get('/project-docs/admin/bilanci')),
  upload: (formData) => unwrap(api.post('/project-docs/admin/bilanci', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })),
  update: (id, body) => unwrap(api.patch(`/project-docs/admin/bilanci/${id}`, body)),
  remove: (id) => unwrap(api.delete(`/project-docs/admin/bilanci/${id}`)),
};

// URL assoluto per aprire/scaricare un documento servito dal backend.
export const projectDocUrl = (relUrl) => `${BACKEND}${relUrl || ''}`;
